import classes from './CommonTitle.module.css';
export default function CommonTitle({title}) {
    return (
        <div className={classes['common-title']}>
            <div className={classes['common-title-left']}>
                <span className={classes['common-title-mark']}></span>
                <span className={classes['common-title-sub']}>{title}</span>
            </div>
            <div className={classes['common-title-right']}>
                <span className={classes['common-title-line']} ></span>
                <span className={classes['common-title-spots']}></span>
            </div>
        </div>
    )
}